import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { initialBooking } from '../initialState'

const bookingSlice = createSlice({
  name: 'booking',
  initialState: initialBooking,
  reducers: {
    updateFieldBooking: (state: any, action: PayloadAction<any>) => {
      state[action.payload.field] = action.payload.value
    },
  },
})
export const bookingAction = bookingSlice.actions
export default bookingSlice
